// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"60":"f0b8c9e7","162":"111339a0","242":"a9d94556","369":"fd6e9c15","393":"3d74a0e8","395":"b17c71bc","532":"55460191","722":"61af9f34","787":"450f1ef8"}[chunkId] + ".chunk.js";
};